import { HAS_CATEGORY } from '@modules/charts/constants';

export const getChartLabelIdOrName = (label?: string) => {
  if (!label) {
    return '';
  }

  return label.split(HAS_CATEGORY)[0];
};
